import React from "react";
import { BrandAdContainer } from "web/react/components/LEGACY-brand-ad-container/brand-ad-container";
import RelatedProductsArea from "web/react/components/LEGACY_related-products-area/related-products-area";
import AdsenseShopping from "web/react/components/adsense-shopping/adsense-shopping";
import Breadcrumbs from "web/react/components/breadcrumbs/breadcrumbs";
import CuratedAds from "web/react/components/curated-ads/curated-ads";
import NewArrivals from "web/react/components/new-arrivals/new-arrivals";
import RecentlyViewed from "web/react/components/recently-viewed/recently-viewed";
import RelatedDesignersRail from "web/react/components/related-designers/related-designers-rail";
import { RelatedSearchesRail } from "web/react/components/related-searches-rail/related-searches-rail";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import { InStockAffiliateProductLayoutSerializer } from "web/types/serializers";
import { breadcrumbs, legacyContainer } from "./pdp-suggested-products.css";

interface PDPSuggestedProductsProps {
    relatedProducts: InStockAffiliateProductLayoutSerializer["related_products"];
    curatedAds: InStockAffiliateProductLayoutSerializer["curated_ads"];
    brandAd: InStockAffiliateProductLayoutSerializer["brand_ad"];
    adsenseForShopping: InStockAffiliateProductLayoutSerializer["adsense_for_shopping"];
    productBreadcrumbs: InStockAffiliateProductLayoutSerializer["product_breadcrumbs"];
    relatedDesignersCategoryRail: InStockAffiliateProductLayoutSerializer["related_designers_category_rail"];
    recentlyViewedProducts: InStockAffiliateProductLayoutSerializer["recently_viewed_products"];
    relatedSearchRail: InStockAffiliateProductLayoutSerializer["related_search_rail"];
    isAuthenticated: InStockAffiliateProductLayoutSerializer["is_authenticated"];
    isFollowing: InStockAffiliateProductLayoutSerializer["is_following"];
    designer: InStockAffiliateProductLayoutSerializer["designer"];
    features: InStockAffiliateProductLayoutSerializer["features"];
}

export function PDPSuggestedProducts({
    relatedProducts,
    curatedAds,
    brandAd,
    adsenseForShopping,
    relatedDesignersCategoryRail,
    recentlyViewedProducts,
    relatedSearchRail,
    isAuthenticated,
    isFollowing,
    designer,
    features,
    productBreadcrumbs,
}: PDPSuggestedProductsProps): JSX.Element {
    const lystId = designer.id;
    const designerName = designer.name;
    const newArrivalProducts = relatedProducts?.sections[1]?.related_products;
    const isLoggedIn = userProfiler.isLoggedIn();
    const showNewArrivalsRail =
        environment.getFeature("mg_show_new_arrivals_rail_pdp") &&
        newArrivalProducts &&
        lystId &&
        designerName &&
        !isLoggedIn;

    const emoPDP = environment.getFeature("cw_pdp_redesign");

    return (
        <View>
            {showNewArrivalsRail && (
                <div className={legacyContainer}>
                    <NewArrivals
                        title={gettext("product.new_arrivals.title", {
                            designer_name: designerName,
                        })}
                        products={newArrivalProducts}
                        designer={{
                            lystId,
                            name: designerName,
                        }}
                        isAuthenticated={isAuthenticated}
                        isFollowing={isFollowing}
                    />
                </div>
            )}

            {(brandAd || adsenseForShopping || relatedProducts || curatedAds) && (
                <div className={legacyContainer}>
                    {curatedAds && <CuratedAds {...curatedAds} usesFeedLayout={false} />}

                    {!curatedAds && brandAd && <BrandAdContainer {...brandAd} />}

                    {!showNewArrivalsRail &&
                        !curatedAds &&
                        adsenseForShopping &&
                        adsenseForShopping.is_at_top && <AdsenseShopping {...adsenseForShopping} />}

                    {relatedProducts && (
                        <RelatedProductsArea
                            // only send related products if using rail
                            sections={
                                showNewArrivalsRail
                                    ? [relatedProducts.sections[0]]
                                    : relatedProducts.sections
                            }
                            noBrandAd={!brandAd}
                            noAdsense={!adsenseForShopping}
                            isAffiliate={true}
                        />
                    )}
                </div>
            )}

            {((showNewArrivalsRail && adsenseForShopping) ||
                (curatedAds && adsenseForShopping && !adsenseForShopping.is_at_top)) && (
                <div className={legacyContainer}>
                    <AdsenseShopping {...adsenseForShopping} />
                </div>
            )}

            {relatedDesignersCategoryRail && !!relatedDesignersCategoryRail.designers.length && (
                <RelatedDesignersRail
                    title={relatedDesignersCategoryRail.title}
                    designers={relatedDesignersCategoryRail.designers}
                    features={features}
                    showImages={false}
                    eventCategory="pdp_designer_feeds_category"
                />
            )}

            {relatedSearchRail && !!relatedSearchRail.related_searches.length && (
                <RelatedSearchesRail
                    title={gettext("product.related_products.related_searches")}
                    relatedSearches={relatedSearchRail.related_searches}
                    features={features as any}
                />
            )}
            {!emoPDP && productBreadcrumbs && (
                <div className={breadcrumbs}>
                    <Breadcrumbs breadcrumbs={productBreadcrumbs.breadcrumbs} type="pdp" />
                </div>
            )}
            <div className={legacyContainer}>
                <RecentlyViewed
                    title={recentlyViewedProducts.title}
                    products={recentlyViewedProducts.products}
                    is_loading={recentlyViewedProducts.is_loading}
                    current_product_id={recentlyViewedProducts.current_product_id}
                    in_overlay={recentlyViewedProducts.in_overlay}
                    isRedesign={!!emoPDP}
                />
            </div>
        </View>
    );
}
